<template>
  <div
    class="course_content use_common"
    :class="{
      course_content_bottom: !isBeginActivity,
      course_content_bottom_iphoneX: isIphoneX,
    }"
  >
    <StudentInfo
      :student-info="defaultStudent"
      :phone="phone"
      :school-id="schoolId"
      @student-info-updated="handleSwitchStudent"
      @contact="handleContact"
      @student-data-ready="handleStudentDataReady"
    />
    <!--活动已结束-->
    <div v-if="!isEndActivity">
      <div v-if="activityInfo.bannerUrl">
        <img class="course_bg" :src="activityInfo.bannerUrl" alt="" />
      </div>

      <!--学员信息区域-->

      <!--筛选器区域-->
      <CourseFilter
        ref="courseFilter"
        :isPackage="true"
        @filter-click="handleFilterClick"
        @filter-count-update="handleFilterCountUpdate"
        @filter-confirm="handleFilterConfirm"
        @get-filtered-class-list="handleGetFilteredPackageList"
      />

      <!--套餐列表区域-->
      <div class="package_list_container">
        <div v-if="filteredPackageList.length > 0">
          <div
            class="package_card"
            v-for="(packageItem, index) in filteredPackageList"
            :key="packageItem.packageCode || index"
            :class="{ package_card_disabled: packageItem.isSoldOut }"
          >
            <!-- 当不允许单独选择班级时，显示选择按钮 -->
            <div v-if="!isAllowedPickClass" class="package_selection">
              <div
                class="selection_radio"
                :class="{ selected: packageItem.isSelectAll }"
                @click.stop.prevent="selectAllPackage(packageItem)"
              ></div>
            </div>
            <!-- 套餐内容区域 -->
            <div
              class="package_content"
              @click="openPackageDetailPopup(packageItem)"
            >
              <!-- 套餐头部 -->
              <div class="package_header">
                <div class="package_info">
                  <div v-if="!isAllowedPickClass" class="package_badge">
                    联报
                  </div>
                  <div class="package_title">
                    {{ packageItem.packageName || "" }}
                  </div>
                  <div>
                    <div class="package_summary">
                      共{{ packageItem.classList?.length || 4 }}个班级
                    </div>
                  </div>
                </div>
                <div class="package_price_section">
                  <div class="package_price">
                    <span>¥</span>{{ packageItem.packagePrice || 7200 }}
                  </div>
                  <!-- 当不允许单独选择班级时，显示选择按钮 -->
                  <div
                    class="package_action_btn"
                    :class="{ selected: packageItem.isSelectAll }"
                  >
                    {{
                      packageItem.isSelectAll
                        ? "已选" + getSelectedCount(packageItem)
                        : "选套餐"
                    }}
                  </div>
                </div>
              </div>

              <!-- 套餐详情 -->
              <div class="package_details">
                <div class="detail_item">
                  <div class="icon calendar_icon"></div>
                  <div class="detail_text">
                    {{ formatDateRange(packageItem) }}
                  </div>
                </div>
                <div class="detail_item">
                  <div class="icon location_icon"></div>
                  <div class="detail_text">
                    {{ getAreaNames(packageItem) }}
                  </div>
                </div>
              </div>

              <!-- 班级卡片列表 -->
              <div class="class_cards_container">
                <div
                  class="class_card"
                  v-for="(classItem, classIndex) in packageItem.classList || []"
                  :key="classItem.classCode || classIndex"
                  :class="getClassCardClass(classItem)"
                >
                  <div class="class_info">
                    {{ getSubjectNames(classItem) }}

                    <div class="class_details">
                      {{
                        getClassLessonTimes(
                          classItem.totalLesson,
                          classItem.totalTime
                        )
                      }}
                    </div>
                  </div>
                  <div
                    class="teacher_info"
                    :class="{
                      teacher_info_empty:
                        classItem.teacherList &&
                        classItem.teacherList.length === 0,
                    }"
                  >
                    <img
                      class="teacher_avatar"
                      :src="getTeacherAvatar(classItem.teacherList)"
                      :alt="getTeacherName(classItem.teacherList)"
                      @error="handleTeacherAvatarError"
                    />
                    <div class="teacher_name">
                      {{ getTeacherName(classItem.teacherList) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div class="empty_state" v-else-if="!isLoadingPackageList">
          <div class="empty_icon">
            <img
              src="https://g.xdfimage.cn/upload/47e011a1ad2fcd201817d92b4b04fd11.png"
              alt="暂无课程"
            />
          </div>
          <div class="empty_text">暂无相关套餐</div>
        </div>

        <!-- 加载状态 -->
        <div
          class="loading_status"
          v-if="filteredPackageList.length > 0 && pullUpState === 2"
        >
          <div class="loading_text">数据加载中...</div>
        </div>

        <!--套餐图片内容-->
        <div class="course_img" v-if="activityInfo.detailUrl">
          <img :src="activityInfo.detailUrl" alt="" />
        </div>
      </div>

      <!--底部按钮-->
      <div
        class="activity_time"
        v-if="!isBeginActivity"
        :class="{ activity_time_bottom: isIphoneX }"
      >
        活动将于{{ beginTimeText }}开始
      </div>
      <div
        class="footer_content flex_box"
        :class="{ footer_content_bottom: isIphoneX }"
      >
        <!-- 全选选项 -->
        <div class="select_all_section">
          <!-- <div
            class="select_all_checkbox"
            :class="{ selected: isAllSelected }"
          ></div> -->
          <!-- <span class="select_all_text">全选</span> -->
          <span class="selected_count"
            >已选<span class="selected_count_number">{{
              getUniqueSelectedCount()
            }}</span
            >项</span
          >
        </div>

        <!-- 购物车 -->
        <div class="cart_section" @click="goToCart">
          <img
            class="cart_icon"
            src="https://g.xdfimage.cn/upload/96382c5b60161cc407538d47b23dd2b1.png"
            alt=""
          />
          <span class="cart_text">购物车</span>
          <span v-if="cartCount > 0" class="cart_badge">{{
            cartCount > 99 ? "99+" : cartCount
          }}</span>
        </div>

        <!-- 双按钮 -->
        <div class="action_buttons">
          <div
            class="add_to_cart_btn"
            :class="{ disabled: !isStudentDataReady }"
            @click="addToCart"
          >
            加入购物车
          </div>
          <div class="register_now_btn" @click="payMoney">立即报名</div>
        </div>
      </div>
    </div>

    <!--活动已结束-->
    <div v-if="isEndActivity">
      <end-activity></end-activity>
    </div>

    <!-- 套餐详情弹层 -->
    <div
      v-if="showPackageDetailPopup"
      class="package_detail_popup_overlay"
      @click="closePackageDetailPopup"
    >
      <div class="package_detail_popup" @click.stop>
        <!-- 弹层头部 -->
        <div class="popup_header">
          <div class="popup_title">选择套餐</div>
          <div class="popup_close" @click="closePackageDetailPopup">
            <img
              src="https://g.xdfimage.cn/upload/481cd50c4a9231e08371cc62f35c4a9b.png"
              alt="关闭"
            />
          </div>
        </div>

        <!-- 可滚动内容区域 -->
        <div class="popup_content">
          <!-- 套餐信息 -->
          <div class="popup_package_info">
            <div class="package_name_price_wrapper">
              <div class="package_name">
                <div v-if="!isAllowedPickClass" class="package_badge">联报</div>
                {{ currentPackageDetail?.packageName || "套餐详情" }}
              </div>
              <div class="package_price">
                <span>¥</span>{{ currentPackageDetail?.packagePrice || 0 }}
              </div>
            </div>
            <div class="package_summary_dates_wrapper">
              <div class="package_summary">
                共{{ currentPackageDetail?.classList?.length || 0 }}个班级
              </div>
              <div class="package_dates">
                <i class="icon-calendar"></i>
                {{ formatDateRange(currentPackageDetail) }}
              </div>
            </div>
          </div>

          <!-- 包含班级列表 -->
          <div class="popup_class_list">
            <div
              class="popup_class_item"
              v-for="(classItem, index) in currentPackageDetail?.classList ||
              []"
              :key="classItem.classCode || index"
              :class="{
                disabled: classItem.saleStatus !== 1,
              }"
            >
              <!-- 班级选择区域 - 只在允许单独选择时显示 -->
              <div
                v-if="isAllowedPickClass"
                class="class_selection_area"
                @click="toggleClassSelection(classItem)"
              >
                <div
                  class="class_checkbox"
                  :class="{
                    selected: tempSelectedClasses.includes(classItem.classCode),
                  }"
                ></div>
              </div>

              <!-- 班级详情区域 -->
              <div
                class="class_detail_area"
                :class="{
                  full_width: !isAllowedPickClass,
                }"
                @click="goToClassDetail(classItem)"
              >
                <div class="class_badges">
                  <!-- quarterList标签显示在最前面 -->
                  <div
                    class="quarter_badge"
                    v-for="(quarter, index) in classItem.quarterList?.filter(
                      (q) => q.key !== '99'
                    )"
                    :key="index"
                  >
                    {{ quarter.name ? quarter.name.charAt(0) : "" }}
                  </div>

                  <!-- 科目标签 -->
                  <!-- <span
                    class="subject_badge"
                    v-for="(subject, index) in classItem.subjectList"
                    :key="'subject-' + index"
                  >
                    {{ subject.name || subject }}
                  </span> -->

                  <!-- 教学方式标签 -->
                  <span
                    class="teaching_method_badge"
                    v-if="
                      classItem.teachingMethod &&
                      classItem.teachingMethod.length > 0
                    "
                  >
                    {{
                      classItem.teachingMethod[0].name ||
                      classItem.teachingMethod[0]
                    }}
                  </span>

                  {{
                    classItem.className || classItem.classTitle || "班级名称"
                  }}
                </div>
                <div class="class_info_row">
                  <div class="class_code">
                    {{ classItem.classCode || "GSX13152" }}
                  </div>
                  <div class="class_lessons">
                    {{
                      getClassLessonTimes(
                        classItem.totalLesson,
                        classItem.totalTime
                      )
                    }}
                  </div>
                  <div class="class_status" v-if="classItem.classState?.name">
                    {{ classItem.classState?.name }}
                  </div>
                </div>
                <div class="class_dates">{{ formatClassDates(classItem) }}</div>
                <div class="class_time">{{ formatClassTime(classItem) }}</div>
                <div class="class_location">
                  {{ classItem.learnPlace || "" }}
                </div>
                <div class="class_teacher">
                  <div class="teachers_section">
                    <!-- 当有老师信息时显示 -->
                    <template
                      v-if="
                        classItem.teacherList &&
                        classItem.teacherList.length > 0
                      "
                    >
                      <div
                        class="teacher_item"
                        v-for="(teacher, index) in classItem.teacherList.slice(
                          0,
                          2
                        )"
                        :key="index"
                      >
                        <div class="teacher_avatar" v-if="teacher.logo">
                          <img
                            :src="teacher.logo"
                            :alt="teacher.name"
                            @error="handleTeacherAvatarError"
                          />
                        </div>
                        <span class="teacher_name">{{ teacher.name }}</span>
                      </div>
                    </template>
                    <!-- 当没有老师信息时显示待定 -->
                    <!-- <div v-else class="teacher_item">
                      <div class="teacher_avatar">
                        <img
                          src="https://g.xdfimage.cn/upload/ac1ffc890c5133c7d980ca22f0d908d3.png"
                          alt="待定"
                        />
                      </div>
                      <span class="teacher_name">待定</span>
                    </div> -->
                  </div>
                </div>
                <div class="class_price">
                  <span class="price_value">{{
                    classItem.salePrice || classItem.price || 900
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 弹层底部 -->
        <div class="popup_footer">
          <!-- 当允许单独选择时，显示全选和已选数量 -->
          <div v-if="isAllowedPickClass" class="select_all_section">
            <div class="select_all_checkbox" @click="toggleSelectAllInPopup">
              <div
                class="checkbox"
                :class="{ selected: isAllSelectedInPopup }"
              ></div>
            </div>
            <span class="select_all_text">全选</span>
            <span class="selected_count"
              >已选<span class="selected_count_number">{{
                getSelectedClassCount()
              }}</span
              >项</span
            >
          </div>

          <!-- 当不允许单独选择时，只显示已选数量 -->
          <div v-else class="selected_count_only">
            <!-- 已选{{ getSelectedClassCount() }}项 -->
          </div>

          <!-- 确认按钮 -->
          <div class="confirm_selection_btn" @click="confirmPackageSelection">
            {{ isAllowedPickClass ? "确认选择" : "选套餐" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wxSdk from "../../libs/wxsdk.js";
import EndActivity from "../../components/endActivity";
import CourseFilter from "../../components/CourseFilter";
import StudentInfo from "../../components/StudentInfo";
import {
  getNewMarketInfo,
  recordChannel,
  getGan,
  getPackageListByFilter,
  addCartApi,
  getCartCountApi,
  getFilterClassCount,
  getCityBySchoolId,
  checkOrderGroup,
} from "../../libs/api";
import {
  formatDateUtil,
  teachingMethodUtil,
  getClassLessonTimesUtil,
  getClassStayUtil,
  isFewUtil,
  getIphoneXType,
  isWeChat,
  getUrlParam,
  navigateToDetail,
} from "../../libs/util";
import configData from "../../libs/conf";
import { showLoadingToast, closeToast, showToast } from "vant";
import Cookies from "js-cookie";
export default {
  name: "packageV2",

  components: {
    "end-activity": EndActivity,
    CourseFilter,
    StudentInfo,
  },
  data() {
    return {
      phone: "",
      pageName: "",
      popupTitle: "", // 弹窗标题
      cityId: "", // 城市Id
      subjectList: [], // 科目列表
      navList: [], // 导航栏
      filterTypeList: [], // 筛选列表
      selectTypeId: "", // 选中筛选类型的Id
      filterNum: "", // 1: 学校 2: 年级  3: 时间
      schoolName: "", // 校区名字
      gradeName: "", // 年级名字
      subjectName: "", // 科目名字
      timeName: "", // 时间名字
      selectSchoolId: "", // 选中的学校Id
      selectGradeId: "", // 选中的校区Id
      selectSubjectId: "", // 选中的科目Id
      selectTimeId: "", // 选中的时间Id
      navNumberList: [], // 导航栏的存在的数字
      navNumberShowString: "", // 导航栏的存在先显示的数字
      selectNavString: "", // 选择学校0，时间1，科目2，显示时间栏
      activityInfo: "", // 活动信息
      beginTimeText: "", // 活动开始时间
      isBeginActivity: true, // 是否开始活动
      isEndActivity: false, // 是否结束活动
      activityId: "", // 活动Id
      channelId: "", // 渠道Id
      pageNumber: 1, // 当前页数
      pageSize: 10, // 一页多少个
      total: "", // 总量
      pullUpState: 1, // 子组件的pullUpState状态
      packageCartList: [], // 套餐购物车
      U2AT: "", // token
      schoolId: "", // 学校Id
      // 以下是信息缓存部分
      campusSet: [], // 校区纬度
      gradeSet: [], // 年级纬度
      subjectSet: [], // 科目纬度
      classTimeSet: [], // 时间纬度
      teacherSet: [], // 教师纬度
      dimensionList: [], // 所有纬度list
      packageList: [], // 套餐列表
      tempPackageList: [], // 临时存储的套餐列表
      classCodeList: [], // 过滤的课程
      packageTitle: "", // 列表标题
      isIosApp: false, // 是否是iosApp
      isIphoneX: false, // 是否iphoneX
      isWeChat: false, //  是否在微信环境内
      wxNickName: "", // 打点微信数据
      agentName: "", // 邮箱或者手机号
      agn: "", // 推广渠道
      isInIframe: false, // 暂时只在推广中心使用
      // 默认学员数据
      defaultStudent: null, // 默认学员信息
      // 是否允许单独选择班级（从活动信息中获取）
      isAllowedPickClass: false,
      // 筛选相关数据
      areaFilters: [], // 地区筛选数据（包含subValues）
      timeFilters: [], // 时间筛选数据（包含subValues的subValues）
      currentFilterParams: null, // 当前的筛选参数（包含所有已分类的筛选数据）
      // 筛选后的套餐列表
      filteredPackageList: [], // 筛选后的套餐列表
      isLoadingPackageList: false, // 是否正在加载套餐列表
      // 全选状态
      isAllSelected: false, // 是否全选
      // 套餐详情弹层相关
      showPackageDetailPopup: false, // 是否显示套餐详情弹层
      currentPackageDetail: null, // 当前查看的套餐详情
      tempSelectedClasses: [], // 临时选中的班级（用于弹层中的选择）
      isAllSelectedInPopup: false, // 弹层中是否全选
      // 购物车数量
      cartCount: 0, // 购物车商品数量
      // 滚动位置
      scrollTop: 0, // 保存滚动位置
      // 学员数据是否已准备就绪
      isStudentDataReady: false, // 学员数据是否已处理完成
    };
  },
  created() {
    let hostname = top.location.hostname;
    if (
      hostname == configData.promotion ||
      hostname == configData.promotionTestOne ||
      hostname == configData.promotionTestTwo ||
      hostname == configData.promotionTestThree
    ) {
      this.isInIframe = true;
    }

    if (top.location != self.location && !this.isInIframe) {
      let queryParams = this.$route.query;
      if (queryParams.pageValue) {
        queryParams = getUrlParam(queryParams.pageValue);
      }
      let activityId = queryParams.activityId || "";
      let channelId = queryParams.channelId || "";
      let agn = queryParams.agn || "";
      let params = `channelId=${channelId}&activityId=${activityId}&agn=${agn}`;
      let url = `/newpackage/v2?${params}`;
      this.$router.push(url);
    }
  },
  mounted() {
    // 从 cookie 中获取 U2AT
    const u2atFromCookie = Cookies.get("U2AT");
    if (u2atFromCookie) {
      this.U2AT = u2atFromCookie;
      console.log("从 cookie 中获取 U2AT:", this.U2AT);
    }

    const appId = configData.appIdWechat;

    // 调用微信绑定SDK
    window.wechatBindSdk
      .checkAuthLogin({
        appId: appId,
        extendFields: "wxNickName",
      })
      .then((res) => {
        console.log("微信绑定SDK", res);
        this.wxNickName = res.wxNickName;
      });
    // 专题详情
    showLoadingToast({
      text: "加载中...",
      spinnerType: "fading-circle",
    });
    let queryParams = this.$route.query;
    // 获取标题参数
    let packageTitle = queryParams;
    // console.log('获取参数', packageTitle)
    if (packageTitle) {
      this.schoolName = packageTitle.schoolName || "";
      this.selectSchoolId = packageTitle.selectSchoolId || "";
      this.gradeName = packageTitle.gradeName || "";
      this.selectGradeId = packageTitle.selectGradeId || "";
      this.subjectName = packageTitle.subjectName || "";
      this.selectSubjectId = packageTitle.selectSubjectId || "";
      this.timeName = packageTitle.timeName || "";
      this.selectTimeId = packageTitle.selectTimeId || "";
      this.filterNum = Number(packageTitle.filterNum) || "";
      this.activityId = packageTitle.activityId || "";
      this.channelId = packageTitle.channelId || "";
      this.agn = packageTitle.agn || "";
      this.selectNavString = packageTitle.selectNavString || "";
      if (packageTitle.selectSchoolId === 0) {
        this.selectSchoolId = 0;
      }
      if (packageTitle.selectGradeId === 0) {
        this.selectGradeId = 0;
      }
      if (packageTitle.selectSubjectId === 0) {
        this.selectSubjectId = 0;
      }
      if (packageTitle.selectTimeId === 0) {
        this.selectTimeId = 0;
      }

      switch (Number(this.filterNum)) {
        case 1: // 校区名字
          this.selectTypeId = this.selectSchoolId;
          break;
        case 2: // 年级名字
          this.selectTypeId = this.selectGradeId;
          break;
        case 3: // 时间名字
          this.selectTypeId = this.selectTimeId;
          break;
        case 4: // 时间名字
          this.selectTypeId = this.selectSubjectId;
          break;
      }
    }

    // 如果已登录，记录渠道
    if (this.U2AT) {
      this.recordChannel();
    }

    // 获取购物车数量
    this.packageCartList = [];
    // 获取纬度及套餐列表
    this.getMarketInfo();
    this.getGan();
    // 获取默认套餐列表
    this.getFilteredPackageList();

    // 打点数据
    gio("page.set", {
      activity_id: this.activityId,
      channel_id: this.channelId,
    });

    // 是否在app内并且是否是ios
    if (xdfJs.xdfhybird.inApp && !xdfJs.xdfhybird.android) {
      this.isIosApp = true;
    }

    // 判断是否IphoneX
    this.isIphoneX = getIphoneXType();

    // 添加滚动监听
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);

    // 组件销毁时恢复页面滚动
    if (this.showPackageDetailPopup) {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
    }
  },
  watch: {},
  methods: {
    // 处理筛选器点击事件
    handleFilterClick(filterInfo) {
      console.log("处理筛选器点击:", filterInfo);
      console.log("筛选数据:", filterInfo.filterData);
    },
    // 处理筛选数量更新事件
    handleFilterCountUpdate(filterData) {
      console.log("筛选数量更新:", filterData);
      // 调用接口获取筛选条件下的班级数量
      this.getFilterClassCount(filterData);
    },
    // 获取筛选条件下的班级数量
    async getFilterClassCount(filterData) {
      try {
        // CourseFilter组件已经传递了正确格式的参数，直接使用
        const params = {
          activityId: filterData.activityId || this.activityId,
          areaFilters: filterData.areaFilters || [],
          timeFilters: filterData.timeFilters || [],
          gradeFilters: filterData.gradeFilters || [],
          subjectFilters: filterData.subjectFilters || [],
          teacherFilters: filterData.teacherFilters || [],
          custom1Filters: filterData.custom1Filters || [],
          custom2Filters: filterData.custom2Filters || [],
          custom3Filters: filterData.custom3Filters || [],
          custom4Filters: filterData.custom4Filters || [],
        };

        console.log("API参数:", params);

        const response = await getFilterClassCount(params);
        console.log("获取筛选班级数量成功:", response);

        // 向子组件发送班级数量更新事件
        // 接口返回的data字段直接就是数量值，不是包含count字段的对象
        this.$refs.courseFilter &&
          this.$refs.courseFilter.updateClassCount(response.data || 0);
      } catch (error) {
        console.error("获取筛选班级数量失败:", error);
      }
    },
    // 处理筛选确认事件
    handleFilterConfirm(filterResult) {
      console.log("筛选确认:", filterResult);
      // 调用获取套餐列表的方法（内部会自动保存筛选参数）
      this.getFilteredPackageList(filterResult);
    },
    // 处理获取筛选套餐列表事件
    handleGetFilteredPackageList(filterParams) {
      console.log("获取筛选套餐列表:", filterParams);
      // 调用获取套餐列表的方法（内部会自动保存筛选参数）
      this.getFilteredPackageList(filterParams);
    },
    // 处理切换学员
    handleSwitchStudent(res) {
      console.log("切换学员");
      console.log("切换学员", res);
      this.defaultStudent = res;
      this.getCartCount();
      // TODO: 实现切换学员的逻辑
      // 可以打开学员选择弹窗或跳转到学员选择页面
    },
    // 处理学员数据准备就绪事件
    handleStudentDataReady(isReady) {
      console.log("学员数据准备就绪:", isReady);
      this.isStudentDataReady = isReady;
    },
    // 处理联系功能
    handleContact() {
      console.log("联系功能");
      // TODO: 实现联系功能的逻辑
      // 可以打开客服弹窗或拨打电话
    },
    // 选择套餐内全部课程
    selectAllPackage(packageItem) {
      if (packageItem.isSoldOut) {
        return;
      }
      if (!this.isAllowedPickClass) {
        // 如果已经选中，则取消选中
        if (packageItem.isSelectAll) {
          this.deselectEntirePackage(packageItem);
        } else {
          // 2.2 不可单独选择班级的套餐——选中套餐左上角圆圈按钮时，如果有部分班级不可报名，显示toast
          if (packageItem.hasUnavailableClasses) {
            showToast({
              message: "当前套餐部分班级无法报名",
              duration: 3000,
              className: "noticeError",
            });
          }
          this.selectEntirePackage(packageItem);
        }
        return;
      }

      // 无论是否允许单独选择班级，都打开详情弹层
      // this.openPackageDetailPopup(packageItem);
    },
    // 选择单个课程
    selectCourse(packageItem, course) {
      if (course.saleStatus !== 1) {
        return; // 不可售卖的班级不能选择
      }

      this.filteredPackageList.forEach((pkg) => {
        if (pkg.packageCode === packageItem.packageCode) {
          pkg.classList.forEach((classItem) => {
            if (classItem.classCode === course.classCode) {
              classItem.isSelect = !classItem.isSelect;
              if (classItem.isSelect) {
                let index = this.packageCartList.indexOf(classItem.productId);
                if (index === -1) {
                  this.packageCartList.push(classItem.productId);
                }
              } else {
                let index = this.packageCartList.indexOf(classItem.productId);
                if (index > -1) {
                  this.packageCartList.splice(index, 1);
                }
              }
            }
          });

          // 检查是否全选
          const selectableCourses = pkg.classList.filter(
            (c) => c.saleStatus === 1
          );
          const selectedCourses = pkg.classList.filter((c) => c.isSelect);
          pkg.isSelectAll =
            selectableCourses.length > 0 &&
            selectedCourses.length === selectableCourses.length;
        }
      });

      this.updateSelectAllStatus();
    },
    // 更新全选状态
    updateSelectAllStatus() {
      if (
        !this.filteredPackageList ||
        !Array.isArray(this.filteredPackageList)
      ) {
        this.isAllSelected = false;
        return;
      }

      // 使用Set来去重，避免重复计算同一个班级
      const uniqueSelectableClasses = new Set();
      const uniqueSelectedClasses = new Set();

      this.filteredPackageList.forEach((pkg) => {
        pkg.classList.forEach((course) => {
          if (course.saleStatus === 1) {
            uniqueSelectableClasses.add(course.classCode);
            if (course.isSelect) {
              uniqueSelectedClasses.add(course.classCode);
            }
          }
        });
      });

      this.isAllSelected =
        uniqueSelectableClasses.size > 0 &&
        uniqueSelectedClasses.size === uniqueSelectableClasses.size;
    },
    // 切换全选状态
    toggleSelectAll() {
      this.isAllSelected = !this.isAllSelected;

      if (this.isAllSelected) {
        // 全选：将所有可选择的课程添加到购物车
        if (
          this.filteredPackageList &&
          Array.isArray(this.filteredPackageList)
        ) {
          this.filteredPackageList.forEach((pkg) => {
            pkg.classList.forEach((course) => {
              if (course.saleStatus === 1 && !course.isSelect) {
                course.isSelect = true;
                if (this.packageCartList.indexOf(course.productId) === -1) {
                  this.packageCartList.push(course.productId);
                }
              }
            });
            // 更新套餐全选状态
            const selectableCourses = pkg.classList.filter(
              (c) => c.saleStatus === 1
            );
            const selectedCourses = pkg.classList.filter((c) => c.isSelect);
            pkg.isSelectAll =
              selectableCourses.length > 0 &&
              selectedCourses.length === selectableCourses.length;
          });
        }
      } else {
        // 取消全选：清空购物车
        if (
          this.filteredPackageList &&
          Array.isArray(this.filteredPackageList)
        ) {
          this.filteredPackageList.forEach((pkg) => {
            pkg.classList.forEach((course) => {
              course.isSelect = false;
            });
            pkg.isSelectAll = false;
          });
        }
        this.packageCartList = [];
      }
    },
    // 跳转到购物车
    goToCart() {
      if (!this.isBeginActivity) {
        showToast({
          message: "当前活动还未开始哦~",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }

      // 直接跳转到购物车页面，不进行登录验证
      let marketingSource = this.activityId + "_" + this.channelId;
      if (this.agn) {
        marketingSource = this.activityId + "_" + this.agn;
      }
      let marketingSourceExt = this.activityInfo.uniActivityId;
      let params =
        `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
        `&studentCode=${
          this.defaultStudent ? this.defaultStudent.studentCode : ""
        }&marketingSource=${marketingSource}&agentName=${
          this.agentName
        }&marketingSourceExt=${marketingSourceExt}`;
      window.parent.location.href = `${configData.h5Bm}/page-h5bm/cart?${params}`;
    },
    // 获取购物车数量
    getCartCount() {
      if (!this.schoolId) {
        console.log("schoolId 未设置，无法获取购物车数量");
        return;
      }
      getCartCountApi({
        schoolId: this.schoolId,
        studentCode: this.defaultStudent ? this.defaultStudent.studentCode : "", // 学员号，可以为空
        appId: configData.appId,
      })
        .then((res) => {
          if (res.code === 10000) {
            this.cartCount = res.data || 0;
            console.log("购物车数量:", this.cartCount);
          }
        })
        .catch((err) => {
          console.error("获取购物车数量失败:", err);
        });
    },
    // 加入购物车
    addToCart() {
      // 检查学员数据是否已准备就绪
      if (!this.isStudentDataReady) {
        showToast({
          message: "正在加载学员信息，请稍候...",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }

      const uniqueSelectedClasses = this.getUniqueSelectedClassCodes();
      if (uniqueSelectedClasses.length === 0) {
        showToast({
          message: "请选择需要加入购物车的课程",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }

      console.log("加入购物车");
      addCartApi({
        schoolId: this.schoolId,
        goodsCode: uniqueSelectedClasses.join(","), // 选择班级（去重后）
        goodsType: 1,
        studentCode: this.defaultStudent ? this.defaultStudent.studentCode : "", // 获取学员号
        studentName: this.defaultStudent ? this.defaultStudent.studentName : "", // 学员姓名
        studentPhone: this.defaultStudent
          ? this.defaultStudent.studentPhone
          : "", // 非必填
        systemSource: configData.systemSource,
        marketingSources: this.activityId + "_" + this.channelId,
        marketingSourcesExt: this.channelId,
        terminal: 2,
        appId: configData.appId,
      })
        .then((res) => {
          if (res.code === 10000) {
            showToast({
              message: "已加入购物车",
              duration: 2000,
              className: "noticeError",
              iconClass: "noticeIcon",
            });
            // 加购完成，清空购物车
            if (
              this.filteredPackageList &&
              Array.isArray(this.filteredPackageList)
            ) {
              this.filteredPackageList.forEach((pkg) => {
                pkg.classList.forEach((classItem) => {
                  classItem.isSelect = false;
                });
                pkg.isSelectAll = false;
              });
            }
            this.packageCartList.length = 0;
            this.isAllSelected = false;

            // 刷新购物车数量
            this.getCartCount();
          } else {
            // 特殊处理登录异常
            if (res.code === 30001) {
              showToast({
                message: "请先登录",
                duration: 2000,
                className: "noticeError",
              });
              return;
            }

            let cartErrorText = "";
            if (res.message) {
              const text = res.message.split("！");
              if (text[1]) {
                cartErrorText = text[1]
                  .replace(/。$/, "")
                  .replace(/。/g, "</div><hr /><div>")
                  .replace(/～/g, "<br />")
                  .replace(/~/g, "<br />");
              } else {
                cartErrorText = text[0];
              }
              // 显示错误信息
              showToast({
                message: cartErrorText,
                duration: 3000,
                className: "noticeError",
              });
            }
            // 清空购物车
            if (
              this.filteredPackageList &&
              Array.isArray(this.filteredPackageList)
            ) {
              this.filteredPackageList.forEach((pkg) => {
                pkg.classList.forEach((classItem) => {
                  classItem.isSelect = false;
                });
                pkg.isSelectAll = false;
              });
            }
            this.packageCartList.length = 0;
            this.isAllSelected = false;
          }
        })
        .catch((error) => {
          console.error("加入购物车失败:", error);
          showToast({
            message: "加入购物车失败，请重试",
            duration: 2000,
            className: "noticeError",
          });
        });
    },
    // 立即报名
    payMoney() {
      if (!this.isBeginActivity) {
        showToast({
          message: "当前活动还未开始哦~",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }
      const uniqueSelectedClasses = this.getUniqueSelectedClassCodes();
      if (uniqueSelectedClasses.length === 0) {
        showToast({
          message: "请选择需要报名的课程",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }

      // 在app中去登陆
      if (xdfJs.xdfhybird.inApp) {
        this.getAppToken();
        return;
      }

      // 下单前调用检查接口
      this.checkOrderBeforePay();
    },
    // 下单前检查订单组
    async checkOrderBeforePay() {
      try {
        // 获取已选班级代码列表
        const uniqueSelectedClasses = this.getUniqueSelectedClassCodes();

        if (uniqueSelectedClasses.length === 0) {
          showToast({
            message: "请选择需要报名的课程",
            duration: 2000,
            className: "noticeError",
          });
          return;
        }

        // 构建 goods 数组
        const goods = uniqueSelectedClasses.map((classCode) => ({
          goodsCode: classCode,
          goodsType: 1,
          schoolId: this.schoolId,
        }));

        // 调用检查接口
        const res = await checkOrderGroup({ goods });

        // 检查通过后继续下单流程
        if (res.code === 10000 || res.code === "200") {
          // 如果只返回了一组，说明可以一起下单
          if (res.data && res.data.groups && res.data.groups.length === 1) {
            const group = res.data.groups[0];
            const goodsType = group.goodsType;

            // goodsType 为 1，使用班级形式下单（classCodes）
            // goodsType 为 2，使用商品形式下单（productIds，保持原有逻辑）
            this.proceedToPay(goodsType, group.goods || []);
          } else {
            // 多组或其他情况，显示提示
            if (res.data && res.data.groups && res.data.groups.length > 1) {
              // 提取所有组的 goodsCode
              const groupCodesList = res.data.groups
                .map((group) => {
                  if (group.goods && Array.isArray(group.goods)) {
                    const codes = group.goods
                      .map((item) => item.goodsCode)
                      .filter((code) => code); // 过滤掉空值
                    return codes.length > 0 ? `【${codes.join("，")}】` : null;
                  }
                  return null;
                })
                .filter((item) => item); // 过滤掉空值

              if (groupCodesList.length > 1) {
                // 格式：【code,code】不能与【code,code】同时下单报名\n请重新选择后再报名
                const message = `${groupCodesList.join(
                  "不能与"
                )}同时下单报名。\n请重新选择后再报名~`;
                showToast({
                  message: message,
                  duration: 5000,
                  className: "noticeError",
                });
              } else {
                showToast({
                  message: "所选课程不能一起下单，请重新选择",
                  duration: 2000,
                  className: "noticeError",
                });
              }
            } else {
              showToast({
                message: "所选课程不能一起下单，请重新选择",
                duration: 2000,
                className: "noticeError",
              });
            }
          }
        } else {
          // 检查失败，显示错误信息
          showToast({
            message: res.message || "订单检查失败，请重试",
            duration: 2000,
            className: "noticeError",
          });
        }
      } catch (error) {
        console.error("订单检查失败:", error);
        showToast({
          message: "订单检查失败，请重试",
          duration: 2000,
          className: "noticeError",
        });
      }
    },
    // 继续下单流程
    proceedToPay(goodsType = 2, goodsList = []) {
      this.recordChannel();
      if (this.U2AT) {
        if (this.packageCartList && this.packageCartList.length === 0) {
          return;
        }
        let url = this.getOrderUrl(goodsType, goodsList);
        window.parent.location.href = url;
      } else {
        // 未登录
        let urlLogin = configData.h5Login;
        let url = this.getOrderUrl(goodsType, goodsList);
        // iframe无论是否登陆跳出
        window.parent.location.href =
          urlLogin + "&redirect_uri=" + encodeURIComponent(url);
      }
    },
    // 获取app的token
    getAppToken() {
      xdfJs.xdfhybird.getUser(async (data) => {
        // 判断用户是否登陆
        if (
          data &&
          data.user &&
          !!data.user.userId &&
          data.user.userId.length > 0
        ) {
          let token = data["user"]["accessToken"];
          this.U2AT = token;
          Cookies.set("U2AT", token, { expires: 30, domain: "xdf.cn" });
          this.recordChannel();

          // 下单前调用检查接口
          try {
            // 获取已选班级代码列表
            const uniqueSelectedClasses = this.getUniqueSelectedClassCodes();

            if (uniqueSelectedClasses.length === 0) {
              showToast({
                message: "请选择需要报名的课程",
                duration: 2000,
                className: "noticeError",
              });
              return;
            }

            // 构建 goods 数组
            const goods = uniqueSelectedClasses.map((classCode) => ({
              goodsCode: classCode,
              goodsType: 1,
              schoolId: this.schoolId,
            }));

            // 调用检查接口
            const res = await checkOrderGroup({ goods });

            // 检查通过后跳转到支付
            if (res.code === 10000 || res.code === "200") {
              // 如果只返回了一组，说明可以一起下单
              if (res.data && res.data.groups && res.data.groups.length === 1) {
                const group = res.data.groups[0];
                const goodsType = group.goodsType;
                let url = this.getOrderUrl(goodsType, group.goods || []);
                if (token) {
                  xdfJs.xdfhybird.openURL("xdfapp://student/web", { url: url });
                }
              } else {
                // 多组或其他情况，显示提示
                if (res.data && res.data.groups && res.data.groups.length > 1) {
                  // 提取所有组的 goodsCode
                  const groupCodesList = res.data.groups
                    .map((group) => {
                      if (group.goods && Array.isArray(group.goods)) {
                        const codes = group.goods
                          .map((item) => item.goodsCode)
                          .filter((code) => code); // 过滤掉空值
                        return codes.length > 0
                          ? `【${codes.join(",")}】`
                          : null;
                      }
                      return null;
                    })
                    .filter((item) => item); // 过滤掉空值

                  if (groupCodesList.length > 1) {
                    // 格式：【code,code】不能与【code,code】同时下单报名\n请重新选择后再报名
                    const message = `${groupCodesList.join(
                      "不能与"
                    )}同时下单报名\n请重新选择后再报名`;
                    showToast({
                      message: message,
                      duration: 5000,
                      className: "noticeError",
                    });
                  } else {
                    showToast({
                      message: "所选课程不能一起下单，请重新选择",
                      duration: 2000,
                      className: "noticeError",
                    });
                  }
                } else {
                  showToast({
                    message: "所选课程不能一起下单，请重新选择",
                    duration: 2000,
                    className: "noticeError",
                  });
                }
              }
            } else {
              // 检查失败，显示错误信息
              showToast({
                message: res.message || "订单检查失败，请重试",
                duration: 2000,
                className: "noticeError",
              });
            }
          } catch (error) {
            console.error("订单检查失败:", error);
            showToast({
              message: "订单检查失败，请重试",
              duration: 2000,
              className: "noticeError",
            });
          }
        } else {
          xdfJs.xdfhybird.openURL("xdfapp://student/login", {});
        }
      });
    },
    // 微信分享
    getWxSdk() {
      let shareObj = {
        urlLogo: this.activityInfo.shareUrl || "", // 分享图标
        desc: this.activityInfo.shareDesc || "",
      };
      shareObj.title = this.activityInfo.shareTitle || this.activityInfo.title;
      let params = this.getParams();
      shareObj.link = configData.originUrl + "newpackage/v2?" + params;
      console.log("shareObj", shareObj);
      wxSdk.getWxSdk(shareObj);
    },
    getParams() {
      let params =
        `activityId=${this.activityId}&channelId=${this.channelId}&schoolName=${this.schoolName}&gradeName=${this.gradeName}&timeName=${this.timeName}&subjectName=${this.subjectName}` +
        `&selectSchoolId=${this.selectSchoolId}&selectGradeId=${this.selectGradeId}&selectTimeId=${this.selectTimeId}&selectSubjectId=${this.selectSubjectId}&selectNavString=${this.selectNavString}&filterNum=${this.filterNum}&agn=${this.agn}`;
      return params;
    },
    // 获取分享链接
    getHttpUrl() {
      let httpUrl = configData.originUrl + "newpackage/v2?";
      let params = this.getParams();
      let url = httpUrl + params;
      return url;
    },
    // ios内打电话
    callPhone() {
      if (!this.isIosApp) {
        return;
      }
      xdfJs.xdfhybird.loadPlugin("XDFHybirdCallPhonePlugin");
      xdfJs.xdfhybird.callPlugin("XDFHybirdCallPhonePlugin", "callPhone", {
        number: Number(this.phone),
      });
    },
    getGan() {
      // 专题详情
      let data = {
        activityId: this.activityId,
        agn: this.agn,
      };
      getGan(data).then((res) => {
        let resData = res;
        if (resData.code == 1) {
          this.agentName = resData.data.agentName;
        }
      });
    },
    // 提取订单URL
    getOrderUrl(goodsType = 2, goodsList = []) {
      let marketingSource = this.activityId + "_" + this.channelId;
      if (this.agn) {
        marketingSource = this.activityId + "_" + this.agn;
      }
      let marketingSourceExt = this.activityInfo.uniActivityId;
      let params = "";

      // goodsType 为 1，使用班级形式下单（classCodes）
      if (goodsType === 1 && goodsList.length > 0) {
        // 从 goodsList 中提取 classCode
        const classCodeList = goodsList.map((item) => item.goodsCode).join(",");
        params =
          `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
          `&classCodes=${classCodeList}&studentCode=&preOrderCode=&marketingSource=${marketingSource}&agentName=${this.agentName}&marketingSourceExt=${marketingSourceExt}`;
      } else {
        // goodsType 为 2，使用商品形式下单（productIds，保持原有逻辑）
        let productIdList = this.getUniqueSelectedProductIds().join(",");
        params =
          `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
          `&productIds=${productIdList}&studentCode=&preOrderCode=&marketingSource=${marketingSource}&agentName=${this.agentName}&marketingSourceExt=${marketingSourceExt}&pageId=a9d4f09c9f38`;
      }

      let orderUrl = `${configData.h5Bm}/page-h5bm/order?${params}`;
      return orderUrl;
    },
    // 处理老师头像加载失败
    handleTeacherAvatarError(event) {
      event.target.src =
        "https://g.xdfimage.cn/upload/ac1ffc890c5133c7d980ca22f0d908d3.png";
    },
    // 查看所有套餐
    checkAllCourse() {
      let params = this.getParams();
      let url = `/newpackage/list?${params}`;
      this.$router.push(url);
    },
    // 教学方式
    teachingMethod(methodCode) {
      return teachingMethodUtil(methodCode);
    },
    // 课时，课次
    getClassLessonTimes(lessonTimes, realMinutes) {
      return getClassLessonTimesUtil(lessonTimes, realMinutes);
    },
    // 住宿班
    getClassStay(modeCodes) {
      return getClassStayUtil(modeCodes);
    },
    // 名额紧张
    isFew(currentNum, maxNum, bmState) {
      return isFewUtil(currentNum, maxNum, bmState);
    },
    // 时间格式化
    formatDate(source, format) {
      try {
        // 确保source是Date对象
        if (!(source instanceof Date)) {
          source = new Date(source);
        }
        // 检查Date对象是否有效
        if (isNaN(source.getTime())) {
          console.warn("无效的日期:", source);
          return "无效日期";
        }
        return formatDateUtil(source, format);
      } catch (error) {
        console.warn("日期格式化错误:", error);
        return "日期错误";
      }
    },
    // 记录渠道
    recordChannel() {
      let data = {
        channelId: this.channelId,
        u2at: this.U2AT,
        wxNickname: this.wxNickName || "",
        agn: this.agn || "",
      };
      recordChannel(data).then((res) => {
        let reaData = res;

        if (reaData.code == 1 && reaData.data && reaData.data.userid) {
          gio("setUserId", reaData.data.userid);
        }
      });
    },

    // 获取专题详情
    getMarketInfo() {
      getNewMarketInfo(this.activityId).then((res) => {
        let resData = res;
        if (resData.code == "200") {
          let data = resData.data;
          this.activityInfo = data.activity;
          this.isAllowedPickClass = data?.marketOn?.isAllowedPickClass;

          // 调试信息：查看活动信息结构
          console.log("活动信息:", this.activityInfo);

          let nowTime = new Date(
            data.nowTime.replace(/-/g, "/") + "+0800"
          ).valueOf();
          let beginTime = new Date(
            this.activityInfo.beginTime.replace(/-/g, "/") + "+0800"
          ).valueOf();
          let beginTimeText = this.formatDate(
            new Date(this.activityInfo.beginTime.replace(/-/g, "/") + "+0800"),
            "MM月dd日 HH:mm"
          );
          let endTime = new Date(
            this.activityInfo.endTime.replace(/-/g, "/") + "+0800"
          ).valueOf();
          this.beginTimeText = beginTimeText;
          this.phone = this.activityInfo.connectPhone;
          this.schoolId = this.activityInfo.schoolId;
          this.pageName = this.activityInfo.title;
          document.title = this.activityInfo.title;

          // 获取城市信息
          this.getCityInfo();

          // 获取购物车数量
          // this.getCartCount();

          // 活动未开始
          if (nowTime < beginTime) {
            this.isBeginActivity = false;
          }
          // 活动已结束
          if (nowTime > endTime) {
            this.isEndActivity = true;
          }

          console.log("getWxSdk");
          // 微信分享
          this.getWxSdk();

          // 缓存信息内容 只有没有选择纬度的情况下再去赋值
        }
      });
    },
    // 存储标题参数

    // 获取筛选后的套餐列表
    getFilteredPackageList(filterParams = null, isLoadMore = false) {
      if (this.isLoadingPackageList) {
        return; // 防止重复请求
      }

      this.isLoadingPackageList = true;
      console.log(
        "开始获取筛选后的套餐列表",
        isLoadMore ? "(加载更多)" : "(首次加载)"
      );

      // 如果传入了新的筛选参数，保存起来供后续使用
      if (filterParams) {
        this.currentFilterParams = filterParams;
      }

      // 构建筛选参数（根据接口文档）
      const params = {
        activityId: parseInt(this.activityId),
        // 分页参数
        pageIndex: isLoadMore ? this.pageNumber : 1,
        pageSize: this.pageSize,
        // 筛选参数（所有参数都是 string[] 类型，使用保存的 currentFilterParams）
        areaFilters: this.currentFilterParams?.areaFilters || [],
        timeFilters: this.currentFilterParams?.timeFilters || [],
        gradeFilters: this.currentFilterParams?.gradeFilters || [],
        subjectFilters: this.currentFilterParams?.subjectFilters || [],
        teacherFilters: this.currentFilterParams?.teacherFilters || [],
        custom1Filters: this.currentFilterParams?.custom1Filters || [],
        custom2Filters: this.currentFilterParams?.custom2Filters || [],
        custom3Filters: this.currentFilterParams?.custom3Filters || [],
        custom4Filters: this.currentFilterParams?.custom4Filters || [],
      };

      console.log("筛选参数:", params);

      // 调用套餐列表API
      getPackageListByFilter(params)
        .then((res) => {
          console.log("套餐列表接口响应:", res);

          if (res.code === "200" || res.status === 200) {
            const newData = res.data || [];

            if (isLoadMore) {
              // 加载更多时，追加数据
              const processedData = this.processPackageData(newData);
              this.filteredPackageList = [
                ...this.filteredPackageList,
                ...processedData,
              ];

              // 如果返回空数组，说明已经加载完毕
              if (newData.length === 0) {
                this.total = this.filteredPackageList.length;
              }
            } else {
              // 首次加载或筛选时，替换数据
              this.filteredPackageList = this.processPackageData(newData);
              this.pageNumber = 1; // 重置页码

              // 如果返回数据不为空，设置一个较大的total值表示可能还有更多数据
              // 如果返回空数组，说明没有数据
              if (newData.length > 0) {
                this.total = 999999; // 设置一个大值，表示可能还有更多数据
              } else {
                this.total = 0;
              }
            }

            console.log("获取到套餐列表:", this.filteredPackageList);
            console.log("套餐数量:", this.filteredPackageList.length);
            console.log(
              "是否还有更多数据:",
              this.filteredPackageList.length < this.total
            );

            // 更新分页状态
            this.updatePullUpState();
          } else {
            console.warn("套餐列表接口返回异常:", res);
            if (!isLoadMore) {
              this.filteredPackageList = [];
              this.total = 0;
            }
          }
        })
        .catch((error) => {
          console.error("获取套餐列表失败:", error);
          if (!isLoadMore) {
            this.filteredPackageList = [];
            this.total = 0;
          }
        })
        .finally(() => {
          this.isLoadingPackageList = false;
          closeToast();
        });
    },
    // 处理套餐数据，添加选择状态
    processPackageData(packageList) {
      return packageList.map((pkg) => {
        // 判断套餐是否可售卖和是否有部分班级不可报名
        let isSoldOut = false;
        let hasUnavailableClasses = false;

        if (
          pkg.classList &&
          Array.isArray(pkg.classList) &&
          pkg.classList.length > 0
        ) {
          const unavailableCount = pkg.classList.filter(
            (course) => course.saleStatus !== 1
          ).length;
          const totalCount = pkg.classList.length;

          // 所有班级都不可报名
          if (unavailableCount === totalCount) {
            isSoldOut = true;
            hasUnavailableClasses = false; // 全部不可报名，不算部分
          }
          // 部分班级不可报名
          else if (unavailableCount > 0 && unavailableCount < totalCount) {
            isSoldOut = false;
            hasUnavailableClasses = true;
          }
          // 全部可报名
          else {
            isSoldOut = false;
            hasUnavailableClasses = false;
          }
        }

        return {
          ...pkg,
          isSelectAll: false,
          isSoldOut: isSoldOut,
          hasUnavailableClasses: hasUnavailableClasses, // 新增字段：是否有部分班级不可报名
          classList: pkg.classList.map((course) => ({
            ...course,
            isSelect: false,
            // 确保数据格式正确
            quarterList: course.quarterList || [],
            subjectList: course.subjectList || [],
            teachingMethod: course.teachingMethod || null,
            totalLesson: course.totalLesson || 0,
            classStartTime: course.classStartTime || "",
            classEndTime: course.classEndTime || "",
            learnTime: course.learnTime || "",
            learnPlace: course.learnPlace || "",
            teacherList: course.teacherList || [],
            price: course.salePrice || 0,
            salePrice: course.salePrice || 0,
          })),
        };
      });
    },

    // 监听滚动事件
    handleScroll() {
      // 获取滚动位置和页面高度
      const scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      const clientHeight =
        document.documentElement.clientHeight || window.innerHeight;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      // 距离底部50px时触发加载
      const threshold = 50;
      const distanceToBottom = scrollHeight - scrollTop - clientHeight;

      // 如果距离底部小于阈值，且可以加载更多，则触发加载
      if (
        distanceToBottom <= threshold &&
        this.pullUpState === 1 &&
        !this.isLoadingPackageList
      ) {
        this.getPullUpMoreData();
      }
    },
    // 更新上拉加载状态
    updatePullUpState() {
      if (!this.filteredPackageList || this.filteredPackageList.length === 0) {
        this.pullUpState = 0; // 没有数据
      } else if (this.filteredPackageList.length >= this.total) {
        this.pullUpState = 3; // 已加载完所有数据
      } else {
        this.pullUpState = 1; // 可以继续加载
      }
    },
    // 上拉一次加载更多的数据
    getPullUpMoreData() {
      // 检查是否还有更多数据可以加载
      if (
        this.filteredPackageList &&
        this.filteredPackageList.length >= this.total
      ) {
        this.pullUpState = 3; // 已加载完所有数据
        return;
      }

      // 增加页码并加载更多数据
      this.pageNumber += 1;
      this.getFilteredPackageList(null, true); // 传递 isLoadMore = true
    },
    // 获取科目数量
    getSubjectCount(packageItem) {
      if (!packageItem.classList || !Array.isArray(packageItem.classList)) {
        return 2; // 默认值
      }
      const subjects = new Set();
      packageItem.classList.forEach((course) => {
        if (course.subjectList && Array.isArray(course.subjectList)) {
          course.subjectList.forEach((subject) => {
            subjects.add(subject.name || subject);
          });
        }
      });
      return subjects.size || 2;
    },
    // 获取已选课程数量
    getSelectedCount(packageItem) {
      if (!packageItem.classList || !Array.isArray(packageItem.classList)) {
        return 0;
      }
      const selectedCount = packageItem.classList.filter(
        (course) => course.isSelect
      ).length;
      return selectedCount;
    },
    // 格式化日期范围
    formatDateRange(packageItem) {
      if (
        packageItem &&
        packageItem.classStartTime &&
        packageItem.classEndTime
      ) {
        try {
          const startDate = this.formatDate(
            new Date(packageItem.classStartTime),
            "yyyy/MM/dd"
          );
          const endDate = this.formatDate(
            new Date(packageItem.classEndTime),
            "yyyy/MM/dd"
          );
          return `${startDate}~${endDate}`;
        } catch (error) {
          console.warn("日期格式化失败:", error);
          return "--";
        }
      }
      return "--"; // 默认值
    },
    // 获取地区名称
    getAreaNames(packageItem) {
      if (
        !packageItem ||
        !packageItem.areaList ||
        !Array.isArray(packageItem.areaList)
      ) {
        return "--";
      }
      // 使用 key 值去重，提取 name 值并用逗号拼接
      const areaMap = new Map();
      packageItem.areaList
        .filter((area) => area && area.key && area.name)
        .forEach((area) => {
          if (!areaMap.has(area.key)) {
            areaMap.set(area.key, area.name);
          }
        });
      const areaNames = Array.from(areaMap.values()).join(",");
      return areaNames || "--";
    },
    // 获取教师姓名
    getTeacherName(teacherList) {
      if (
        !teacherList ||
        !Array.isArray(teacherList) ||
        teacherList.length === 0
      ) {
        return "待定";
      }
      return teacherList[0].name || teacherList[0].teacherName || "待定";
    },
    // 获取教师头像
    getTeacherAvatar(teacherList) {
      if (
        !teacherList ||
        !Array.isArray(teacherList) ||
        teacherList.length === 0
      ) {
        return "https://g.xdfimage.cn/upload/ac1ffc890c5133c7d980ca22f0d908d3.png";
      }
      return (
        teacherList[0].logo ||
        teacherList[0].avatar ||
        teacherList[0].teacherAvatar ||
        "https://g.xdfimage.cn/upload/ac1ffc890c5133c7d980ca22f0d908d3.png"
      );
    },
    // 获取班级卡片样式类
    getClassCardClass(classItem) {
      // 获取班级的科目信息
      const subjectName = this.getSubjectName(classItem);

      // 根据科目名称返回对应的样式类
      const subjectClassMap = {
        数学: "class_card_math",
        物理: "class_card_physics",
        英语: "class_card_english",
        语文: "class_card_chinese",
        历史: "class_card_history",
        政治: "class_card_politics",
        生物: "class_card_biology",
        地理: "class_card_geography",
        化学: "class_card_chemistry",
        科学: "class_card_science",
        其他: "class_card_other",
      };

      return "class_card_other";
    },
    // 获取班级的科目名称
    getSubjectName(classItem) {
      if (
        classItem.subjectList &&
        Array.isArray(classItem.subjectList) &&
        classItem.subjectList.length > 0
      ) {
        // 如果有多个科目，返回"其他"
        if (classItem.subjectList.length > 1) {
          return "其他";
        }
        // 如果只有一个科目，返回该科目名称
        const subject = classItem.subjectList[0];
        return subject.name || subject;
      }

      // 如果没有科目信息，尝试从班级名称中提取
      const className = classItem.className || classItem.classTitle || "";
      if (className.includes("数学")) return "数学";
      if (className.includes("物理")) return "物理";
      if (className.includes("英语")) return "英语";
      if (className.includes("语文")) return "语文";
      if (className.includes("历史")) return "历史";
    },
    // 获取科目名称列表（最多三个）
    getSubjectNames(classItem) {
      if (
        classItem.subjectList &&
        Array.isArray(classItem.subjectList) &&
        classItem.subjectList.length > 0
      ) {
        // 如果有多个科目，返回"多科"
        if (classItem.subjectList.length > 1) {
          return "多科";
        }
        // 如果只有一个科目，返回该科目名称
        const subject = classItem.subjectList[0];
        return subject.name || subject;
      }

      // 如果没有科目信息，返回通用科目
      return "通用科目";
    },
    // 打开套餐详情弹层
    openPackageDetailPopup(packageItem) {
      this.currentPackageDetail = { ...packageItem };
      // 初始化临时选择状态
      this.tempSelectedClasses = [];
      this.isAllSelectedInPopup = false;

      // 只有在允许单独选择班级时才需要初始化选择状态
      if (
        this.isAllowedPickClass &&
        packageItem.classList &&
        Array.isArray(packageItem.classList)
      ) {
        packageItem.classList.forEach((classItem) => {
          if (classItem.isSelect) {
            this.tempSelectedClasses.push(classItem.classCode);
          }
        });
        // 检查是否全选
        this.updatePopupSelectAllStatus();
      }

      this.showPackageDetailPopup = true;
      // 禁止页面滚动（移动端兼容方案）
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      document.body.style.position = "fixed";
      document.body.style.top = `-${this.scrollTop}px`;
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
    },
    // 关闭套餐详情弹层
    closePackageDetailPopup() {
      this.showPackageDetailPopup = false;
      this.currentPackageDetail = null;
      this.tempSelectedClasses = [];
      this.isAllSelectedInPopup = false;
      // 恢复页面滚动（移动端兼容方案）
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
      document.documentElement.scrollTop = this.scrollTop;
      document.body.scrollTop = this.scrollTop;
    },
    // 切换班级选择状态（弹层中）
    toggleClassSelection(classItem) {
      if (classItem.saleStatus !== 1) {
        return; // 不可售卖的班级不能选择
      }

      // 如果不允许单独选择班级，不允许取消选择
      if (!this.isAllowedPickClass) {
        return;
      }

      const index = this.tempSelectedClasses.indexOf(classItem.classCode);
      if (index > -1) {
        this.tempSelectedClasses.splice(index, 1);
      } else {
        this.tempSelectedClasses.push(classItem.classCode);
      }

      // 更新全选状态
      this.updatePopupSelectAllStatus();
    },
    // 获取弹层中已选班级数量
    getSelectedClassCount() {
      // 如果不允许单独选择班级，返回套餐中所有班级的数量
      if (!this.isAllowedPickClass) {
        return this.currentPackageDetail?.classList?.length || 0;
      }
      return this.tempSelectedClasses.length;
    },
    // 更新弹层中的全选状态
    updatePopupSelectAllStatus() {
      if (
        !this.currentPackageDetail?.classList ||
        !Array.isArray(this.currentPackageDetail.classList)
      ) {
        this.isAllSelectedInPopup = false;
        return;
      }

      const selectableClasses = this.currentPackageDetail.classList.filter(
        (classItem) => classItem.saleStatus === 1
      );

      this.isAllSelectedInPopup =
        selectableClasses.length > 0 &&
        selectableClasses.every((classItem) =>
          this.tempSelectedClasses.includes(classItem.classCode)
        );
    },
    // 切换弹层中的全选状态
    toggleSelectAllInPopup() {
      if (
        !this.currentPackageDetail?.classList ||
        !Array.isArray(this.currentPackageDetail.classList)
      ) {
        return;
      }

      this.isAllSelectedInPopup = !this.isAllSelectedInPopup;

      if (this.isAllSelectedInPopup) {
        // 2.1 可单独选择班级的套餐——在套餐详情弹层，选中全选按钮时，如果有部分班级不可报名，显示toast
        if (this.currentPackageDetail.hasUnavailableClasses) {
          showToast({
            message: "当前套餐部分班级无法报名",
            duration: 3000,
            className: "noticeError",
          });
        }

        // 全选：选择所有可选择的班级
        this.currentPackageDetail.classList.forEach((classItem) => {
          if (
            classItem.saleStatus === 1 &&
            !this.tempSelectedClasses.includes(classItem.classCode)
          ) {
            this.tempSelectedClasses.push(classItem.classCode);
          }
        });
      } else {
        // 取消全选：清空选择
        this.tempSelectedClasses = [];
      }
    },
    // 确认套餐选择
    confirmPackageSelection() {
      if (!this.currentPackageDetail) {
        return;
      }

      // 如果不允许单独选择班级，直接选择整个套餐
      if (!this.isAllowedPickClass) {
        // 2.2 不可单独选择班级的套餐——在套餐详情弹层点击选套餐按钮时，如果有部分班级不可报名，显示toast
        if (this.currentPackageDetail.hasUnavailableClasses) {
          showToast({
            message: "当前套餐部分班级无法报名",
            duration: 3000,
            className: "noticeError",
          });
        }
        this.selectEntirePackage(this.currentPackageDetail);
        this.closePackageDetailPopup();
        return;
      }

      // 允许单独选择班级时的逻辑
      this.filteredPackageList.forEach((pkg) => {
        if (pkg.packageCode === this.currentPackageDetail.packageCode) {
          if (pkg.classList && Array.isArray(pkg.classList)) {
            pkg.classList.forEach((classItem) => {
              const isSelected = this.tempSelectedClasses.includes(
                classItem.classCode
              );
              classItem.isSelect = isSelected;

              // 更新购物车列表
              const cartIndex = this.packageCartList.indexOf(
                classItem.productId
              );
              if (isSelected && cartIndex === -1) {
                this.packageCartList.push(classItem.productId);
              } else if (!isSelected && cartIndex > -1) {
                this.packageCartList.splice(cartIndex, 1);
              }
            });
          }

          // 更新套餐选择状态
          const selectedCount = this.tempSelectedClasses.length;
          pkg.isSelectAll = selectedCount > 0;
        }
      });

      // 更新全选状态
      this.updateSelectAllStatus();

      // 关闭弹层
      this.closePackageDetailPopup();
    },
    // 选择整个套餐
    selectEntirePackage(packageItem) {
      this.filteredPackageList.forEach((pkg) => {
        if (pkg.packageCode === packageItem.packageCode) {
          if (pkg.classList && Array.isArray(pkg.classList)) {
            pkg.classList.forEach((course) => {
              if (course.saleStatus === 1) {
                course.isSelect = true;
                let index = this.packageCartList.indexOf(course.productId);
                if (index === -1) {
                  this.packageCartList.push(course.productId);
                }
              }
            });
          }
          pkg.isSelectAll = true;
        }
      });

      this.updateSelectAllStatus();
    },
    // 取消选择整个套餐
    deselectEntirePackage(packageItem) {
      this.filteredPackageList.forEach((pkg) => {
        if (pkg.packageCode === packageItem.packageCode) {
          if (pkg.classList && Array.isArray(pkg.classList)) {
            pkg.classList.forEach((course) => {
              course.isSelect = false;
              let index = this.packageCartList.indexOf(course.productId);
              if (index > -1) {
                this.packageCartList.splice(index, 1);
              }
            });
          }
          pkg.isSelectAll = false;
        }
      });

      this.updateSelectAllStatus();
    },
    // 跳转到班级详情页
    goToClassDetail(classItem) {
      // 使用简化的跳转方法
      navigateToDetail(this.cityId, this.schoolId, classItem.classCode);
    },
    // 格式化班级日期
    formatClassDates(classItem) {
      if (classItem && classItem.classStartTime && classItem.classEndTime) {
        try {
          const startDate = this.formatDate(
            new Date(classItem.classStartTime),
            "yyyy/MM/dd"
          );
          const endDate = this.formatDate(
            new Date(classItem.classEndTime),
            "yyyy/MM/dd"
          );
          return `${startDate}~${endDate}`;
        } catch (error) {
          console.warn("班级日期格式化失败:", error);
          return "2025/07/08~2025/07/17";
        }
      }
      return "2025/07/08~2025/07/17";
    },
    // 格式化班级时间
    formatClassTime(classItem) {
      if (classItem.learnTime) {
        return classItem.learnTime;
      }
      return "每天08:00-10:00";
    },
    // 获取去重后的已选班级数量
    getUniqueSelectedCount() {
      if (
        !this.filteredPackageList ||
        !Array.isArray(this.filteredPackageList)
      ) {
        return 0;
      }

      const uniqueSelectedClasses = new Set();
      this.filteredPackageList.forEach((pkg) => {
        pkg.classList.forEach((course) => {
          if (course.isSelect) {
            uniqueSelectedClasses.add(course.classCode);
          }
        });
      });

      return uniqueSelectedClasses.size;
    },
    // 获取去重后的已选班级代码列表
    getUniqueSelectedClassCodes() {
      if (
        !this.filteredPackageList ||
        !Array.isArray(this.filteredPackageList)
      ) {
        return [];
      }

      const uniqueSelectedClasses = new Set();
      this.filteredPackageList.forEach((pkg) => {
        pkg.classList.forEach((course) => {
          if (course.isSelect) {
            uniqueSelectedClasses.add(course.classCode);
          }
        });
      });

      return Array.from(uniqueSelectedClasses);
    },
    // 获取去重后的已选产品ID列表
    getUniqueSelectedProductIds() {
      if (
        !this.filteredPackageList ||
        !Array.isArray(this.filteredPackageList)
      ) {
        return [];
      }

      const uniqueSelectedProductIds = new Set();
      this.filteredPackageList.forEach((pkg) => {
        pkg.classList.forEach((course) => {
          if (course.isSelect && course.productId) {
            uniqueSelectedProductIds.add(course.productId);
          }
        });
      });

      return Array.from(uniqueSelectedProductIds);
    },
    // 获取城市信息
    getCityInfo() {
      if (!this.schoolId) {
        console.warn("schoolId is empty, cannot get city info");
        return;
      }

      getCityBySchoolId(this.schoolId)
        .then((res) => {
          console.log("获取城市信息响应:", res);
          if (res.status === 1 && res.data && Array.isArray(res.data)) {
            // 找到isPrimary为true的那条
            const primaryCity = res.data.find(
              (item) => item.isPrimary === true
            );
            if (primaryCity) {
              this.cityId = primaryCity.cityId;
              console.log("获取到主要城市ID:", this.cityId);
            } else {
              console.warn("未找到isPrimary为true的城市信息");
            }
          } else {
            console.warn("获取城市信息失败:", res.message);
          }
        })
        .catch((error) => {
          console.error("获取城市信息失败:", error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../less/variables.less";

.course_content {
  padding-bottom: 100px;
  background: #f6f7fc;
  min-height: 100vh;

  .course_bg {
    width: 100%;
  }

  /* 课程列表容器 */
  .course_list_container {
    margin-top: -419px; /* 向上的负margin */
  }

  /*查看全部课程*/
  .check_all_course {
    justify-content: center;
    margin-top: 56px;
    margin-bottom: 60px;
    .all_course_title {
      font-size: 24px;
      color: rgba(252, 148, 53, 1);
      line-height: 34px;
      margin-right: 20px;
    }
    .course_left_arrow {
      width: 10px;
      height: 18px;
    }
  }
}
.course_content_bottom {
  padding-bottom: 170px;
}
.course_content_bottom_iphoneX {
  padding-bottom: 168px;
}

/* 套餐列表容器 */
.package_list_container {
  margin-top: -398px; /* 向上的负margin，与筛选器重叠 */
  padding-bottom: 50px;
}

/* 套餐卡片样式 */
.package_card {
  background: #fff;
  border-radius: 16px;
  margin: 24px auto;
  padding: 40px 0 40px 40px;
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 686px;
  box-sizing: border-box;
  &.package_card_disabled {
    > * {
      opacity: 0.6;
    }
    cursor: not-allowed;
    .package_selection .selection_radio {
      background-image: url("../../assets/check_disable.png") !important;
    }
  }

  .package_selection {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 20px;

    .selection_radio {
      width: 40px;
      height: 40px;
      background-image: url("../../assets/checkbox.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      border: none;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      cursor: pointer;

      &.selected {
        background-image: url("https://g.xdfimage.cn/upload/1267067df6b9e40254456c757631fd45.png");
      }
    }
  }

  .package_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 578px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .package_header {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    min-width: 0;
    width: 100%;
    padding-right: 40px;

    .package_info {
      flex: 1;
      margin-right: 16px;
      min-width: 0;
      font-size: 0;

      .package_badge {
        display: inline-block;
        background: linear-gradient(270deg, #e4a970 35%, #f3b273 100%);
        color: white;
        font-size: 24px;
        border-radius: 6px;
        margin-right: 8px;
        vertical-align: middle;
        padding: 7px 8px;
        line-height: 22px;
      }

      .package_title {
        display: inline;
        font-size: 32px;
        font-weight: 600;
        color: @text-primary;
        line-height: 40px;
        margin-bottom: 8px;
        vertical-align: middle;
        word-break: break-word;
        overflow-wrap: break-word;
      }

      .package_summary {
        font-size: 24px;
        color: #ff7638;
        line-height: 24px;
        margin-top: 16px;
        display: inline-block;
        background: #fff3e7;
        line-height: 24px;

        padding: 6px;
        border-radius: 6px;
      }
    }

    .package_price_section {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      flex-shrink: 0;
      min-width: 0;
      width: 120px;

      .package_price {
        margin-top: -1px;
        font-size: 40px;
        font-weight: 600;
        line-height: 40px;
        color: #ff6b35;
        margin-bottom: 8px;

        text-align: right;

        overflow: hidden;
        text-overflow: ellipsis;
        span {
          font-size: 24px;
        }
      }

      .package_action_btn {
        padding: 10px 16px;
        background: linear-gradient(90deg, #ff5f28 0%, #ff692b 100%);
        color: white;
        border-radius: 40px;
        font-size: 24px;
        font-weight: 500;
        cursor: pointer;
        line-height: 28px;
        text-align: center;
        white-space: nowrap;
        max-width: 100%;
        box-sizing: border-box;

        &.selected {
          background: #fff;
          color: #ff6b35;
          border: 2px solid #ff6b35;
        }
      }

      .package_detail_btn {
        padding: 12px 24px;
        background: #f0f0f0;
        color: #666;
        border-radius: 20px;
        font-size: 24px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        text-align: center;
        min-width: 120px;
        border: 1px solid #ddd;
      }
    }
  }

  .package_details {
    margin-bottom: 24px;

    .detail_item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .icon {
        width: 32px;
        height: 32px;
        flex-shrink: 0;
        margin-right: 12px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;

        &.calendar_icon {
          background-image: url("../../assets/calendar.png");
        }

        &.location_icon {
          background-image: url("../../assets/location.png");
        }
      }

      .detail_text {
        font-size: 24px;
        color: #666;
        line-height: 32px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .class_cards_container {
    display: flex;
    gap: 16px;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 8px;
    scroll-behavior: smooth;

    padding-right: 32px;

    /* 隐藏滚动条但保持滚动功能 */
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    .class_card {
      flex-shrink: 0;
      width: 216px;

      padding: 40px 20px 32px 20px;
      border-radius: 12px;
      display: flex;
      flex-direction: column;

      // 数学
      &.class_card_math {
        background: linear-gradient(180deg, #dcfaef 0%, #f6fcfa 70%);
        .class_info {
          color: #0bb072;
        }
      }

      // 物理
      &.class_card_physics {
        background: linear-gradient(180deg, #e0e8ff 0%, #f7f9ff 61%);
        .class_info {
          color: #5378ee;
        }
      }

      // 英语
      &.class_card_english {
        background: linear-gradient(180deg, #fff4e1 0%, #fffcf7 61%);
        .class_info {
          color: #f39a00;
        }
      }

      // 语文
      &.class_card_chinese {
        background: linear-gradient(180deg, #fde7e4 0%, #fdf9f8 61%);
        .class_info {
          color: #f75f4e;
        }
      }

      // 历史
      &.class_card_history {
        background: linear-gradient(180deg, #ffebe3 0%, #fffbfa 61%);
        .class_info {
          color: #ff743d;
        }
      }

      // 政治
      &.class_card_politics {
        background: linear-gradient(180deg, #f7ebe6 1%, #fcf9f7 61%);
        .class_info {
          color: #b26743;
        }
      }

      // 生物
      &.class_card_biology {
        background: linear-gradient(180deg, #fce1e8 0%, #fcf7fa 61%);
        .class_info {
          color: #ee4574;
        }
      }

      // 地理
      &.class_card_geography {
        background: linear-gradient(180deg, #e6fad9 0%, #f9fcf7 61%);
        .class_info {
          color: #51bf11;
        }
      }

      // 化学
      &.class_card_chemistry {
        background: linear-gradient(180deg, #eae3fc 0%, #fbfaff 61%);
        .class_info {
          color: #8d65f3;
        }
      }

      // 科学
      &.class_card_science {
        background: linear-gradient(180deg, #d9f4fc 0%, #f8fcfd 61%);
        .class_info {
          color: #12aee4;
        }
      }

      // 其他
      &.class_card_other {
        background: linear-gradient(180deg, #d7faf5 0%, #f8fdfc 61%);
        .class_info {
          color: #17b9a4;
        }
      }

      .class_info {
        font-weight: 600;
        font-size: 36px;
        margin-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .class_details {
          font-size: 24px;
          line-height: 32px;
          margin-top: 8px;
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .teacher_info {
        display: flex;
        align-items: center;
        margin-top: 40px;
        &.teacher_info_empty {
          opacity: 0;
        }

        .teacher_avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 8px;
        }

        .teacher_name {
          font-size: 20px;
          color: #868c9b;
        }
      }
    }
  }
}

/* 空状态样式 */
.empty_state {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;

  margin-top: -374px;
  justify-content: center;
  padding: 120px 40px;
  text-align: center;
  background: #fff;
  border-radius: 16px;
  width: 686px;

  .empty_icon {
    margin-bottom: 4px;

    img {
      width: 320px;
      height: 260px;
    }
  }

  .empty_text {
    font-size: 24px;
    color: #868c9b;
  }
}

/* 新的课程卡片样式 */
.course_card {
  display: flex;
  background: #fafbfc;
  border-radius: 16px;
  margin: 16px 0;
  padding: 24px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;

  &.course_card_disabled {
    > * {
      opacity: 0.6;
    }
    cursor: not-allowed;
  }

  .course_selection {
    margin-right: 16px;
    display: flex;
    align-items: center;

    .selection_radio {
      width: 40px;
      height: 40px;
      background-image: url("../../assets/checkbox.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      border: none;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;

      &.selected {
        background-image: url("https://g.xdfimage.cn/upload/1267067df6b9e40254456c757631fd45.png");
      }
    }
  }

  .course_info_content {
    flex: 1;
    display: flex;
    flex-direction: column;

    .course_header {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 16px;
      .quarter_badge {
        box-sizing: border-box;
        width: 34px;
        height: 32px;
        padding: 4px 6px;
        background: linear-gradient(132deg, #09d0c8 0%, #1de4b7 96%);
        border-radius: 6px;
        font-size: 22px;
        color: @bg-primary;
        line-height: 24px;
        font-weight: 500;
        margin-right: 8px;
        margin-bottom: 8px;
        text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.08);
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .subject_badge {
        padding: 3px 6px;
        background: #defff7;
        border: 1px solid #2cd4b0;
        border-radius: 6px;
        font-size: 22px;
        color: #21c2a0;
        font-weight: 500;
        line-height: 24px;
        margin-right: 8px;
        margin-bottom: 8px;
        height: 32px;
        display: inline-flex;
        align-items: center;
        box-sizing: border-box;
      }
      .teaching_method_badge {
        padding: 3px 6px;
        background: #fff;
        border: 1px solid #21c2a0;
        border-radius: 6px;
        font-size: 22px;
        color: #21c2a0;
        font-weight: 500;
        line-height: 24px;
        margin-right: 8px;
        margin-bottom: 8px;
        height: 32px;
        display: inline-flex;
        align-items: center;
        box-sizing: border-box;
      }
    }

    .course_details {
      display: flex;
      flex-direction: column;

      .detail_item {
        display: flex;
        align-items: center;

        font-size: 26px;
        line-height: 32px;
        color: #5a606f;
        &.detail_info {
          margin-bottom: 16px;
        }
        .icon {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          margin-right: 8px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;

          &.calendar_icon {
            background-image: url("../../assets/calendar.png");
          }

          &.clock_icon {
            background-image: url("../../assets/time.png");
          }

          &.location_icon {
            background-image: url("../../assets/location.png");
          }
        }

        .detail_text {
          font-size: 20px;
          line-height: 22px;
          padding: 6px 8px;
          margin-right: 8px;
          margin-bottom: 32px;
        }
        .lessonNum {
          background: rgba(16, 161, 209, 0.1);
          color: #6c81a1;
        }
        .classCode {
          color: #549393;
          background: rgba(24, 209, 179, 0.1);
        }

        .status_badge {
          font-size: 20px;
          line-height: 22px;
          padding: 6px 8px;
          background: #f2f4f9;
          color: #929ab0;
        }
      }
    }

    .course_footer {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      margin-top: 32px;

      .teachers_section {
        display: flex;

        .teacher_item {
          display: flex;
          align-items: center;
          gap: 12px;

          .teacher_avatar {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 8px;
          }

          .teacher_name {
            font-size: 24px;
            color: #464b58;
            margin-right: 24px;
          }
        }
      }

      .price_section {
        margin-top: 32px;
        display: flex;
        justify-content: flex-end;
        color: #ff6b35;
        align-items: baseline;
        font-size: 24px;
        .price {
          font-size: 40px;
          font-weight: 600;
          color: #ff6b35;
        }
      }
    }
  }
}

/* 底部样式 */
.footer_content {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  background: @bg-primary;
  border-top: 1px solid @border-light;
  padding: 24px 20px;
  /* iOS 安全区适配：所有设备 24px + 安全区域 */
  padding-bottom: calc(
    constant(safe-area-inset-bottom) + 24px
  ); /* iOS 11.0-11.2 兼容 */
  padding-bottom: calc(env(safe-area-inset-bottom) + 24px); /* iOS 11.2+ */
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1000;

  &.footer_content_bottom {
    /* iOS 安全区适配：所有设备 24px + 安全区域 */
    padding-bottom: calc(
      constant(safe-area-inset-bottom) + 24px
    ); /* iOS 11.0-11.2 兼容 */
    padding-bottom: calc(env(safe-area-inset-bottom) + 24px); /* iOS 11.2+ */
  }

  /* 全选选项 */
  .select_all_section {
    display: flex;
    align-items: center;
    cursor: pointer;
    flex: 1;

    .select_all_checkbox {
      width: 40px;
      height: 40px;
      background-image: url("../../assets/checkbox.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      border: none;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      transition: all 0.3s ease;

      &.selected {
        background-image: url("../../assets/selected.png");
      }
    }

    .select_all_text {
      font-size: 28px;
      color: #3d3d3d;
      margin-right: 8px;
    }

    .selected_count {
      font-size: 24px;
      color: @text-light;
      .selected_count_number {
        color: #21242c;
        font-weight: 500;
        margin-left: 8px;
        margin-right: 8px;
      }
    }
  }

  /* 购物车 */
  .cart_section {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    margin: 0 20px;
    position: relative;

    .cart_icon {
      width: 40px;
      height: 40px;
      margin-bottom: 4px;
    }

    .cart_text {
      font-size: 20px;
      color: @text-primary;
    }

    .cart_badge {
      position: absolute;
      top: -8px;
      right: -8px;
      min-width: 24px;
      height: 24px;
      padding: 2 6px;
      border: 1px solid #ffffff;
      background: #ff7161;
      color: #fff;
      line-height: 20px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 14px;
      font-size: 18px;
    }
  }

  /* 双按钮 */
  .action_buttons {
    display: flex;
    height: 76px;

    border-radius: 64px;
    overflow: hidden;

    .add_to_cart_btn {
      width: 176px;
      background: linear-gradient(114deg, #ffb93c -1%, #ff9b19 106%);
      color: @bg-primary;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      padding: 12px 0;

      &.disabled {
        background: #cccccc !important;
        cursor: not-allowed !important;
        opacity: 0.6 !important;
        pointer-events: none;
      }
    }

    .register_now_btn {
      padding: 12px 0;
      width: 176px;
      background: #ff6b35;
      color: @bg-primary;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
    }
  }
}

/* 套餐详情弹层样式 */
.package_detail_popup_overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0;
}

.package_detail_popup {
  background: #f5f8fa;
  border-radius: 16px 16px 0 0;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.3s ease-out;
  transform: translateY(0);
}

.popup_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 32px 24px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;

  .popup_title {
    font-size: 36px;
    font-weight: 600;
    color: @text-primary;
    flex: 1;
    text-align: left;
  }

  .popup_close {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }

    cursor: pointer;

    position: absolute;
    right: 32px;
  }
}

.popup_content {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  margin: 16px 32px 0;
  background: #fff;
  border-radius: 16px 16px 0 0;
  padding: 40px 40px 0 40px;
}

.popup_package_info {
  padding-bottom: 24px;

  .package_name_price_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .package_name {
      font-size: 32px;
      font-weight: 600;
      color: #333;
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .package_badge {
        display: inline-block;
        padding: 7px 8px;
        background: linear-gradient(270deg, #e4a970 35%, #f3b273 100%);
        color: white;
        font-size: 24px;
        border-radius: 6px;
        margin-right: 8px;
        line-height: 22px;
      }
    }

    .package_price {
      font-size: 40px;
      span {
        font-size: 24px;
      }
      font-weight: 600;
      color: #ff6b35;
    }
  }

  .package_summary_dates_wrapper {
    font-size: 0;
    .package_summary {
      display: inline-block;
      font-size: 24px;
      color: #ff6b35;
      background: #fff3e7;
      padding: 6px;
      margin-bottom: 16px;
      border-radius: 6px;
      line-height: 24px;
    }

    .package_dates {
      font-size: 24px;
      color: #5a606f;
      display: flex;
      align-items: center;

      .icon-calendar {
        width: 32px;
        height: 32px;
        margin-right: 8px;
        background: url("https://g.xdfimage.cn/upload/ef6c0c06ca48e9fddd1872c5800bb78b.png")
          no-repeat center;
        background-size: contain;
      }
    }
  }
}

.popup_class_list {
  .popup_class_item {
    display: flex;
    padding: 40px 0;
    cursor: pointer;
    position: relative;
    border-top: 2px solid #f5f6fa;

    &.disabled {
      cursor: not-allowed;

      > * {
        opacity: 0.6;
      }

      .class_selection_area .class_checkbox {
        background-image: url("../../assets/check_disable.png");
      }
    }

    .class_selection_area {
      margin-right: 20px;
      display: flex;
      align-items: center;

      .class_checkbox {
        width: 40px;
        height: 40px;
        background-image: url("../../assets/checkbox.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        border: none;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;

        &.selected {
          background-image: url("../../assets/selected.png");
        }
      }
    }

    .class_detail_area {
      flex: 1;
      display: flex;
      flex-direction: column;

      &.full_width {
        width: 100%;
        margin-left: 0;
      }

      .class_badges {
        align-items: center;
        margin-bottom: 16px;
        font-size: 32px;
        font-weight: 600;
        color: @text-primary;
        line-height: 40px;
        margin-left: 8px;
        margin-bottom: 8px;

        .quarter_badge {
          vertical-align: 4px;
          box-sizing: border-box;
          width: 34px;
          height: 32px;
          padding: 4px 6px;
          background: linear-gradient(132deg, #09d0c8 0%, #1de4b7 96%);
          border-radius: 6px;
          font-size: 22px;
          color: @bg-primary;
          line-height: 24px;
          font-weight: 500;
          margin-right: 8px;
          margin-bottom: 8px;
          text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.08);
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .subject_badge {
          vertical-align: 4px;
          padding: 3px 6px;
          background: #defff7;
          border: 1px solid #2cd4b0;
          border-radius: 6px;
          font-size: 22px;
          color: #21c2a0;
          font-weight: 500;
          line-height: 24px;
          margin-right: 8px;
          margin-bottom: 8px;
          height: 32px;
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          box-sizing: border-box;
        }

        .teaching_method_badge {
          vertical-align: 4px;
          padding: 3px 6px;
          background: #fff;
          border: 1px solid #21c2a0;
          border-radius: 6px;
          font-size: 22px;
          color: #21c2a0;
          font-weight: 500;
          line-height: 24px;
          margin-right: 8px;
          margin-bottom: 8px;
          height: 32px;
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          box-sizing: border-box;
        }
      }

      .class_info_row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 16px;
        gap: 8px;
      }

      .class_code {
        font-size: 20px;
        line-height: 22px;
        padding: 6px 8px;
        margin-right: 8px;
        color: #549393;
        background: rgba(24, 209, 179, 0.1);
        display: inline-flex;
        align-items: center;
        border-radius: 6px;
      }

      .class_lessons {
        font-size: 20px;
        line-height: 22px;
        padding: 6px 8px;
        margin-right: 8px;
        background: rgba(16, 161, 209, 0.1);
        color: #6c81a1;
        display: inline-flex;
        align-items: center;
        border-radius: 6px;
      }

      .class_status {
        font-size: 20px;
        line-height: 22px;
        padding: 6px 8px;
        background: #f2f4f9;
        color: #929ab0;
        display: inline-flex;
        align-items: center;
        border-radius: 6px;
      }

      .class_dates {
        display: flex;
        align-items: center;
        font-size: 26px;
        line-height: 32px;
        color: #5a606f;
        margin-bottom: 16px;

        &::before {
          content: "";
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          margin-right: 8px;
          background-image: url("../../assets/calendar.png");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }

      .class_time {
        display: flex;
        align-items: center;
        font-size: 26px;
        line-height: 32px;
        color: #5a606f;
        margin-bottom: 16px;

        &::before {
          content: "";
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          margin-right: 8px;
          background-image: url("../../assets/time.png");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }

      .class_location {
        display: flex;
        align-items: center;
        font-size: 26px;
        line-height: 32px;
        color: #5a606f;
        margin-bottom: 32px;

        &::before {
          content: "";
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          margin-right: 8px;
          background-image: url("../../assets/location.png");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }

      .class_teacher {
        margin-bottom: 32px;

        .teachers_section {
          display: flex;
          flex-direction: row;
          gap: 16px;
          flex-wrap: wrap;

          .teacher_item {
            display: flex;
            align-items: center;
            font-size: 28px;
            color: #464b58;

            .teacher_avatar {
              width: 56px;
              height: 56px;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 12px;
              flex-shrink: 0;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .teacher_name {
              flex: 1;
              font-size: 24px;
            }
          }
        }
      }

      .class_price {
        display: flex;
        justify-content: flex-end;
        color: #ff6b35;
        align-items: baseline;
        font-size: 24px;

        &::before {
          content: "¥";
        }

        .price_value {
          font-size: 40px;
          font-weight: 600;
          color: #ff6b35;
        }
      }
    }
  }
}

.popup_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  /* iOS 安全区适配：所有设备 24px + 安全区域 */
  padding-bottom: calc(
    constant(safe-area-inset-bottom) + 24px
  ); /* iOS 11.0-11.2 兼容 */
  padding-bottom: calc(env(safe-area-inset-bottom) + 24px); /* iOS 11.2+ */
  border-top: 1px solid #f0f0f0;
  background: #fff;

  .select_all_section {
    display: flex;
    align-items: center;
    flex: 1;

    .select_all_checkbox {
      margin-right: 12px;
      cursor: pointer;

      .checkbox {
        width: 40px;
        height: 40px;
        background-image: url("../../assets/checkbox.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        border: none;
        border-radius: 50%;
        transition: all 0.3s ease;

        &.selected {
          background-image: url("../../assets/selected.png");
        }
      }
    }

    .select_all_text {
      font-size: 24px;
      color: #21242c;
      margin-right: 12px;
      font-weight: 500;
    }

    .selected_count {
      font-size: 24px;
      color: #666;
      .selected_count_number {
        color: #21242c;
        font-weight: 500;
        margin-left: 8px;
        margin-right: 8px;
      }
    }
  }

  .selected_count_only {
    flex: 1;
    font-size: 24px;
    color: #666;
  }

  .confirm_selection_btn {
    background: linear-gradient(114deg, #ffb93c -1%, #ff9b19 106%);
    color: white;
    border-radius: 20px;
    font-size: 28px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
    height: 76px;
    line-height: 76px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 64px;
    width: 430px;
  }
}

/* 弹层动画 */
@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

/* 加载状态样式 */
.loading_status {
  padding: 40px 0;
  text-align: center;
  color: #999;
  font-size: 24px;

  .loading_text {
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      content: "";
      width: 28px;
      height: 28px;
      margin-right: 12px;
      border: 3px solid #e0e0e0;
      border-top-color: #21c2a0;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 课程图片样式 */
.course_img {
  width: 100%;
  margin-top: 20px;

  img {
    width: 100%;
    display: block;
  }
}
</style>
